import { render, staticRenderFns } from "./addParaseRcord.vue?vue&type=template&id=6e8a5bd2&scoped=true"
import script from "./addParaseRcord.vue?vue&type=script&lang=js"
export * from "./addParaseRcord.vue?vue&type=script&lang=js"
import style0 from "./addParaseRcord.vue?vue&type=style&index=0&id=6e8a5bd2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8a5bd2",
  null
  
)

export default component.exports